export default function Icon (){
    return(
        <section>
        <div className="typewriter">
            <a className="text-decoration-none" href="/">
            <h1 className="gradient-text">Tasks</h1>
            </a>
        </div>
        </section>
    )
}
